import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import FranchisePartnerForm from './forms/FranchisePartnerForm';
import FranchisePartnerList from './lists/FranchisePartnerList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import connect from "../../reducers/connect";
import {postData, sendRequest} from "../../utils/request";
import {purchasesEditor as PurchaseEditor} from "./purchaseEditor";
import ContentLoader from "../layout/ContentLoader";

class FranchisePartnerEditor extends React.Component {

    state = {
        isLoading: false,
        pos: []
    }

    componentDidMount() {
        this.loadFranchiseList();
    }

    loadFranchiseList = async () => {
        this.franchiseRequest && this.franchiseRequest.abort();
        this.setState({isLoading: true}, () => {
            this.franchiseRequest = sendRequest({
                option: "componentlist",
                component: "FranchisePartner",
                view: {"franchise": {"id": ""}},
                filter: {field: "partner_id", value: this.props.pos.partner.partner_id},
                itemsperpage: 0,
            });
            this.franchiseRequest.then((data) => {
                const franchiseIds = data.items.map((item) => {
                    return item.franchise.id
                });
                sendRequest({
                    option: "componentlist",
                    component: "Franchise",
                    view: {"pos": {"id": ""}},
                    filter: {field: "id", value: franchiseIds, operator: "in"},
                    itemsperpage: 0,
                }).then((data) => {
                    this.setState({
                        pos: data.items.map((item) => {
                            return item.pos.id;
                        }),
                        isLoading: false,
                    });
                });
            });
        });
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    getFieldProps = (name) => {
        const props = this.props.getFieldProps(name);
        props.disabled = true;
        return props;
    }

    getFieldsProps = (name) => {
        let props = this.props.getFieldsProps(name);
        Object.keys(props).map((key) => props[key].disabled = true);
        return props;
    }

    createConsignmentSale = async () => {
        await this.props.processAction(async () => {
            return await postData({
                action: this.props.componentConfig.componentname + '.createConsignmentSale',
                [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield]
            });
        });
    }

    render() {
        if (this.state.isLoading) {
            return <ContentLoader />;
        }
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const Other = this.props.other || Fragment;
        return <Fragment>
            <List
                {...this.props}
                collapsed={this.props.collapsed || false}
                theme="default"
                header="Franchise partnerek"
            >
                <FranchisePartnerList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
            </List>
            {this.props.values[this.props.componentConfig.idfield] && <Editor
                {...this.props}
                ref={(editor) => this.editor = editor}
                theme="default"
                header="Franchise partner"
                footer={[
                    <Button
                        key="0"
                        disabled={this.props.dirty || this.props.isLoading}
                        color="primary"
                        className="pull-right"
                        onClick={this.createConsignmentSale}
                    >
                        Elszámolás
                    </Button>
                ]}
            >
                <FranchisePartnerForm {...this.props} getFieldProps={this.getFieldProps} getFieldsProps={this.getFieldsProps} />
            </Editor>}
            {this.props.values.partner_id && <Other>
                <PurchaseEditor
                    listFilter={[{field: "customer", value: this.props.values.partner_id}]}
                    pos={this.state.pos}
                />
            </Other>}
        </Fragment>;
    }
}

export default connect((state) => {
    return {
        pos: state.app.till.pos,
    }
})(createEditor({
    componentName: "FranchisePartner",
    WrappedComponent: FranchisePartnerEditor
}));
